import { SITE } from "@/data/site";

const crumbSchema = (crumbs, path) => ({
  "@type": "BreadcrumbList",
  itemListElement: [{ label: "Home", href: "/" }, ...crumbs].map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.label,
    item: `${SITE.url}${c.href || path}`,
  })),
});

const faqSchema = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

// Per-page SEO: title, description, canonical, Open Graph and JSON-LD. React 19 hoists these into <head>.
export const Seo = ({ title, description, path = "/", image, crumbs, faqs, schema = [] }) => {
  const url = `${SITE.url}${path}`;
  const og = image?.startsWith("http") ? image : `${SITE.url}${image || SITE.ogImage}`;
  const graph = [...schema];
  if (crumbs?.length) graph.push(crumbSchema(crumbs, path));
  if (faqs?.length) graph.push(faqSchema(faqs));
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={og} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={og} />
      {graph.length > 0 && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({ "@context": "https://schema.org", "@graph": graph }) }} />
      )}
    </>
  );
};

export const serviceSchema = (name, serviceType, areas) => ({
  "@type": "Service",
  name,
  serviceType,
  provider: { "@id": `${SITE.url}/#business` },
  areaServed: (areas || ["Huntersville", "Cornelius", "Denver", "Sherrills Ford", "Iron Station"]).map((a) => ({ "@type": "City", name: `${a}, NC` })),
});
